import React, { Component } from 'react';
import { Container, Alert } from 'reactstrap';

class RegisterSucceed extends Component {

    componentDidMount() {
        localStorage.clear();
    }

    render() {
        return (
            <Container>
                <h1>Pendaftaran Nasabah Berhasil</h1>
                <Alert color="success">Kode referensi Anda: <b>{new URLSearchParams(window.location.href.split('?')[1])}</b></Alert>
                <Alert color="warning">
                <p><b>Terima kasih, Proses Pembukaan Rekening Efek Anda sedang diproses.</b></p>
                <p>Perlu diketahui bahwa selama proses pembukaan Rekening Efek ini,
                    Anda akan mendapatkan beberapa email baik dari <b>YB Sekuritas</b> maupun dari
                    <b>Pihak Ketiga</b> (Bank RDN/KSEI/KPEI).</p>
                <p>Mohon diperhatikan bahwa tahapan <b>Deposit Awal pada Bank RDN</b> Anda hanya dapat dilakukan
                    <b>setelah Anda menerima email dari ayodepositsekarang@juc.co.id</b>.
                    Apabila Anda melakukan Deposit Awal <b>sebelum mendapatkan email tersebut</b>,
                        maka proses Deposit Awal Anda <b>berisiko terhambat</b>.</p>
                    </Alert>
               
            </Container>
        );
    }
}

export default RegisterSucceed;



// WEBPACK FOOTER //
// ./src/components/RegisterSucceed.js